import {useMemo} from 'react'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {useGetAverageAge, useGetGender} from '../../core/_query'
import {CategoryTreatmentBarChart} from './CategoryTreatmentBarChart'

type Props = {
  isMitra: boolean
}

const GenderChart: React.FC<Props> = ({isMitra = false, }) => {

  const {state} = useQueryRequest()
  const {data: trendCategories} = useGetGender({...state, set_is_job_therapist: isMitra ?? false})

  const sorted = useMemo(() => {
    return (trendCategories?.response?.data || []).reverse()
  }, [trendCategories])

  const arrayOfSeriesscategory = useMemo(() => {
    return sorted?.map((x) => x?.total || 0)
  }, [trendCategories])

  const arrayOfLabelscategory = useMemo(() => {
    return sorted?.map((x) => x.gender)
  }, [trendCategories])

  return (
    <CategoryTreatmentBarChart
      className='shadow-wit-2'
      color='primary'
      title='Gender'
      isCurrency={false}
      series={[
        {
          name: 'Total',
          data: arrayOfSeriesscategory,
        },
      ]}
      categories={arrayOfLabelscategory}
    />
  )
}

export {GenderChart}
